import styles from './index.module.scss';

interface ApsPartnerPromotionProps {
  link: string;
  image: string;
  title: string;
  subtitle: string;
  backgroundColor: string;
  fontColor: string;
}

export const ApsPartnerPromotion = ({
  link,
  image,
  title,
  subtitle,
  backgroundColor,
  fontColor,
}: ApsPartnerPromotionProps) => (
  <a
    className={styles.item}
    target="_blank"
    rel="noopener noreferrer"
    href={link}
    style={{
      backgroundImage: `url(${image})`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      backgroundPosition: 'right',
      backgroundClip: backgroundColor,
      color: fontColor,
    }}
  >
    <div>{title}</div>
    <div>{subtitle}</div>
  </a>
);
